module.exports = __webpack_public_path__ + "static/img/default-image-notfound.9d5918c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/default-image-notfound.jpg
// module id = 34
// module chunks = 1